import { Action } from "utils";

export const INITIAL_STATE = {
  response: [],
};

export const profileDetailReducer = (state = INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case "PROFILE_DETAILS_FULFILLED":
      return {
        status: "success",
        data: action.payload.data.data ? action.payload.data.data : [],
      };

    case "PROFILE_DETAILS_PENDING":
      return {
        status: "pending",
      };

    case "PROFILE_DETAILS_LIST":
      return {
        response: [],
      };

    default:
      return {
        ...state,
      };
  }
};
